<div [alarisLoading]="loading$">
	<div class="edit-panel-header">
		<alaris-icon name="icon-sender"></alaris-icon>
		{{ 'senderIds.requestSenderId' | translate }}
	</div>
	<div alarisFade="vertical" class="edit-panel-content">
		<form [formGroup]="senderIdForm" id="senderIdForm" class="form-group" alarisFocusFirstInvalidInput>
			<fieldset>
				<alaris-input
					[label]="'senderIds.senderId' | translate"
					[placeholder]="'senderIds.senderId' | translate"
					errorMode="touched"
					data-testid="nameInput"
					formControlName="name"
				>
				</alaris-input>
				<alaris-multi-select2
					[label]="'senderIds.channels' | translate"
					[optionsCount]="(channelService.list$ | async)?.length || 0"
					[placeholder]="'senderIds.channels' | translate"
					errorMode="touched"
					data-testid="channelsSelect"
					formControlName="channels"
					selectedLabel="name"
				>
					@for (opt of channelService.list$ | async; track $index) {
						<alaris-multi-options2 [attr.data-testid]="'channelsOptions/' + opt.name" [value]="opt">
							{{ opt.name }}
						</alaris-multi-options2>
					}
				</alaris-multi-select2>
			</fieldset>

			@if (hasWhatsappChannel) {
				<ng-container [formGroup]="whatsappSettingsForm">
					<fieldset>
						<b>{{ 'gl.general' | translate }}</b>
						<alaris-input
							[label]="'fc.wabaId' | translate"
							[placeholder]="'fc.wabaId' | translate"
							data-testid="businessManagerIdInput"
							formControlName="businessManagerId"
						>
						</alaris-input>
						<alaris-input
							[label]="'fc.phoneNumber' | translate"
							[placeholder]="'fc.phoneNumber' | translate"
							data-testid="phoneInput"
							formControlName="phone"
							maskPattern="9*"
						>
							<div extra>
								<alaris-icon
									[alarisTooltip]="'senderIds.phoneNote' | translate"
									[maxWidth]="236"
									[name]="'icon-circle-help'"
								>
								</alaris-icon>
							</div>
						</alaris-input>
					</fieldset>
					<fieldset>
						<div class="additional-title">
							<b>{{ 'senderIds.additional' | translate }}</b>
							<div class="secondary">{{ 'senderIds.additionalNote' | translate }}</div>
						</div>
						<div class="logo-loader">
							{{ 'fc.campaignLogo' | translate }}
							<alaris-file-loader
								(fileListChanges)="updateLogo($event)"
								[exportInternally]="true"
								[height]="182"
								[files]="[]"
								[multiple]="false"
								data-testid="logoFile"
								fileTypes=".png,.jpg"
							>
								<div note class="logo-note">{{ 'gl.minResolution' | translate }} 400x400px</div>
							</alaris-file-loader>
						</div>
						<alaris-text-area
							[placeholder]="'senderIds.businessDescriptionNote' | translate"
							data-testid="descriptionTextarea"
							formControlName="description"
						>
							{{ 'fc.businessDescription' | translate }}
						</alaris-text-area>
						<alaris-input
							[label]="'fc.address' | translate"
							[placeholder]="'fc.address' | translate"
							data-testid="addressInput"
							formControlName="address"
						>
						</alaris-input>
						<alaris-input
							[label]="'fc.email' | translate"
							[placeholder]="'fc.email' | translate"
							data-testid="emailInput"
							formControlName="email"
						>
						</alaris-input>
						<alaris-input
							[label]="'fc.website' | translate"
							[placeholder]="'fc.website' | translate"
							data-testid="websiteInput"
							formControlName="website"
						>
							<div extra>
								<alaris-icon
									[alarisTooltip]="'senderIds.websiteNote' | translate"
									[maxWidth]="236"
									[name]="'icon-circle-help'"
								>
								</alaris-icon>
							</div>
						</alaris-input>
					</fieldset>
				</ng-container>
			}

			<fieldset>
				<alaris-file-loader
					(fileListChanges)="updateDocuments($event)"
					[exportInternally]="true"
					fileTypes=".doc,.docx,.xls,.xlsx,.pdf,.zip,.rar"
					[height]="182"
					[maxSize]="20 * 1024 * 1024"
					data-testid="documentFile"
				>
					{{ 'gl.documents' | translate }}
				</alaris-file-loader>
				@if (senderIdForm.get('comment')?.value) {
					<alaris-text-area data-testid="commentTextarea" formControlName="comment">
						{{ 'gl.comment' | translate }}
					</alaris-text-area>
				} @else {
					<button
						(click)="senderIdForm.get('comment')?.setValue(' ')"
						class="reset add-comment"
						data-testid="add-comment"
					>
						{{ 'gl.addComment' | translate }}
					</button>
				}
			</fieldset>
			<alaris-custom-form [form]="customForm" [fields]="customFields" type="creating" errorMode="touched">
			</alaris-custom-form>
		</form>
	</div>
	<div class="edit-panel-footer">
		<button
			(click)="save()"
			alaris-button
			bType="primary"
			data-testid="createBtn"
			size="lg"
			type="submit"
			form="senderIdForm"
		>
			<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
			{{ 'actions.create' | translate }}
		</button>
		<button (click)="close()" alaris-button bType="outline" data-testid="closeBtn" size="lg" type="button">
			{{ 'actions.cancel' | translate }}
		</button>
	</div>
</div>
